import { render } from "./FileViewerInline.vue?vue&type=template&id=62c1963a&scoped=true"
import script from "./FileViewerInline.vue?vue&type=script&lang=js"
export * from "./FileViewerInline.vue?vue&type=script&lang=js"

import "./FileViewerInline.vue?vue&type=style&index=0&id=62c1963a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c1963a"]])

export default __exports__